import React, {useContext, useState} from "react";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../../ToolBar/ToolBarUtils/ItemTypes";
import RenderComponents from "../RenderByType/RenderComponents";
import {IconButton, makeStyles} from "@material-ui/core";
import {MoreVertOutlined} from "@material-ui/icons";
import ContextMenu from "./ContextMenu";
const initialContextState = {
    mouseX: null,
    mouseY: null,
};
const useStyles = makeStyles(() => ({
    tdMenu: {
        position: 'absolute',
        top: 0,
        right: 0,
        border: '1px solid #dedede !important',
        borderRadius: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    td: {
        position: 'relative',
        '& $tdMenu': {
            visibility: 'hidden'
        },
        '&:hover': {
            '& $tdMenu': {
                visibility: 'visible'
            }
        }
    }
}))
const TableCellComponent = ({cellIndex, rowIndex, component, path, parentIndex, parentPath}) => {
    const {properties: {colSpan = 1} = {}, styles: sourceStyles, children = []} = component;
    const {
        onDropComponent,
        onDropMultipleComponents,
        onMoveComponent,
        onSelectComponent,
        onDeleteComponent,
        dropInEveryChild
    } = useContext(ScreenDesignerContextNew);
    const [contextMenu, setContextMenu] = useState(initialContextState);
    const classes = useStyles();
    const styles = sourceStyles ? sourceStyles[0] : {};
    const hasChildren = children && children.length;
    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.column,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            let newItem = {...item};
            if (didDrop) {
                return;
            }
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                };
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(item.component, 0, `${path}.children`);
                return
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    item.component = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(item.component, item.from, `${path}.children`, children.length, item.index, parentIndex);
                return
            }

            onDropComponent(newItem, children.length, `${path}.children`)
        }
    });

    function onSelect(e) {
        e.stopPropagation()
        onSelectComponent(component, path);
    }
    const closeContextMenu = () => {
        setContextMenu(initialContextState)
    };

    function removeItem() {
        onDeleteComponent(path, component.type)
    }

    function addItem(direction, rowIndex) {
        if(rowIndex === 0) {
            dropInEveryChild({
                type: 'tableTd',
                styles: [{}],
                children: []
            }, parentPath)

            return;
        }

    }
    const renderer = (
        <>
            {hasChildren ? (
                children.map((item, index) => {
                    return (
                        <RenderComponents
                            key={index}
                            type={item.type}
                            item={item}
                            index={index}
                            path={`${path}.children.${index}`}
                            parentPath={path}
                        />
                    )
                })
            ) : (
                isOverCurrent && (
                    <div style={{background: '#009688', height: 10, alignSelf: 'center', width: '100%'}}>

                    </div>
                )
            )}
            <div className={classes.tdMenu}>
                <IconButton size="small"

                            onClick={(e) => setContextMenu({mouseX: e.clientX - 2,mouseY: e.clientY - 4})}>
                    <MoreVertOutlined/>
                </IconButton>
            </div>
            <ContextMenu
                contextMenu={contextMenu}
                onClose={closeContextMenu}
                removeItem={removeItem}
                addItem={(direction) => addItem(direction, rowIndex)}
            />
        </>
    )

    if (rowIndex === 0) {
        return (
            <th className={classes.td} ref={drop} style={{padding: 3, width: styles.width, background: styles.background}}
                onClick={onSelect}
                colSpan={colSpan}
            >
                <div style={{display: 'flex'}}>
                {renderer}
                </div>
            </th>
        )
    }
    return (
        <td className={classes.td} ref={drop} style={{padding: 3, background: styles.background}}
            onClick={onSelect}
            colSpan={colSpan}
        >
            <div style={{display: 'flex', flexDirection: "column", overflow: 'auto'}}>
                {renderer}
            </div>
        </td>
    )
}
export default TableCellComponent